import { RootState } from "../store";

export const getAllBeaches = (state: RootState) => state.beach.allBeaches;
export const getBeach = (state: RootState) => state.beach.beach;
export const getCreatedBeach = (state: RootState) => state.beach.createdBeach;
export const getDeletedBeach = (state: RootState) => state.beach.deletedBeach;
export const getUpdatedBeach = (state: RootState) => state.beach.updatedBeach;
export const getSeatIdByMatrix = (state: RootState) => (
  progressiveNumber: number,
  row: number
) =>
  getBeach(state).data?.seats?.find(
    (f) => f.progressiveNumber === progressiveNumber && f.row === row
  );
export const getBeachById = (state: RootState) => (id: string) => {
  return state.beach.allBeaches.data?.results.find((f) => f.id === id);
};
